module.exports = __webpack_public_path__ + "h5/img/mask_img1.c424f888.png";